<template>
  <el-dialog top="5vh"
             title=""
             :visible.sync="dialogFormVisible"
             :modal-append-to-body="false"
             @close="emitClose"
             @open="open"
             width="600px">
    <el-form label-width="90px">
      <el-form-item label="学管师">
        <el-select v-model="form.watcher"
                   filterable
                   placeholder="请选择"
                   style="width: 400px"
                   @change='$forceUpdate()'>
          <el-option v-for="(item,index) in $store.state.staffOptions.filter((v) => {
                return (
                  v.depts.findIndex((t) => {
                    return t.id == 4 && v.status == 1;
                  }) != -1
                );
              })"
                     :key="index"
                     :label="item.nickname"
                     :value="item.id">
            <span> {{ `${item.nickname}-${item.phone}` }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程待办">
        <el-select v-model="arr_course_id"
                   filterable
                   multiple
                   placeholder="请选择"
                   style="width: 400px"
                   @change='ff()'>
          <el-option v-for="(item,index) in tableDate"
                     :key="index"
                     :label="item.course_name"
                     :value="item.id">
            <span> {{item.course_name}}</span>
          </el-option>
        </el-select>

      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="emitClose">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { courseList } from '../../../request/api'

export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    learn_manager_id: {
      default: null,
    },
    courseList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      tableVisible: false,
      form: {},
      arr_course_id: null,
      tableDate: [],
    }
  },
  mounted() {
    this.$store.dispatch('getStaffOptions')
  },
  watch: {
    isVisible(val) {
      this.form = {}
      this.form.watcher = this.learn_manager_id
      this.dialogFormVisible = val
    },
    courseList(val) {
      if (val) {
        console.log('valks', val)
        this.arr_course_id = val
      }
    },
  },
  methods: {
    open() {
      let query = { pageIndex: 1, pageSize: 10, isPaging: 0 }
      query.statuses = 1
      courseList(query).then((res) => {
        this.tableDate = res.data.data.list
      })
    },
    ff() {
      console.log('this.arr_course_id', this.arr_course_id)
    },
    tableClose() {
      this.tableVisible = false
    },
    chooseTable() {
      this.tableVisible = true
    },
    emitClose() {
      this.$emit('close')
    },
    submit() {
      console.log('this.arr_course_id', this.arr_course_id)
      this.$emit('submit', { watcher: this.form.watcher }, this.arr_course_id)
      // this.arr_course_id = null
    },
  },
}
</script>

<style lang="less" scoped>
.chooseCourse {
  cursor: pointer;
  color: #409eff;
}
.tips {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #303133;
  opacity: 1;
}
.count-content {
  height: 55px;
  text-align: center;
  margin-bottom: 36px;
  span {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    line-height: 55px;
    color: #e6a23c;
    opacity: 1;
  }
}
.tax-rate {
  margin-top: 24px;
  span {
    margin-left: 16px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 18px;
    color: #c0c4cc;
    opacity: 1;
  }
}
</style>